import React from "react";
import {
  FooterLogo,
  FooterPermaLinkItem,
  FooterPermaLinkItemArchor,
  FooterPermalinks,
  FooterSocials,
  FooterSocialsLink,
  FooterWrapper,
  FooterCopyright,
  FooterCopyrightText,
} from "./styles";
import { FaFacebookF } from "react-icons/fa";
import { FiInstagram } from "react-icons/fi";
import { IoLogoTwitter } from "react-icons/io";
import { BsFillTelephoneForwardFill} from "react-icons/bs";
import {AiOutlineMail} from "react-icons/ai";
const Footer = ({data}) => {
  return (
    <FooterWrapper>
      <FooterLogo href="#"> {data.FIRMA}</FooterLogo>

      <FooterPermalinks>

        <FooterPermaLinkItem>
          {data.ADRES ?
            <FooterPermaLinkItemArchor>
              {data.ADRES}
            </FooterPermaLinkItemArchor>
            : ""}
        </FooterPermaLinkItem>
        <FooterPermaLinkItem>
          {data.TELEFON ?
            <FooterPermaLinkItemArchor
            href= {"tel:"+data.TELEFON}
            target="_blank"
            >
              <BsFillTelephoneForwardFill/>
              <span>   {data.TELEFON}</span>
             
            </FooterPermaLinkItemArchor>
            : ""}
        </FooterPermaLinkItem>
        <FooterPermaLinkItem>
          {data.WEB ?
            <FooterPermaLinkItemArchor>
              {data.WEB}
            </FooterPermaLinkItemArchor>
            : ""}
        </FooterPermaLinkItem>
        <FooterPermaLinkItem
       
        >
          {data.MAIL ?
            <FooterPermaLinkItemArchor
            href={"mailto:"+data.MAIL}
            target="_blank"
            >
              <AiOutlineMail/>
              <span>     {data.MAIL}</span>
            
            </FooterPermaLinkItemArchor>
            : ""}
        </FooterPermaLinkItem>

       
      </FooterPermalinks>

      <FooterSocials>
        <FooterSocialsLink 
        href={"https://www.facebook.com/profile.php?id="+data.FACEBOOK}
        target="_blank"
        rel="noopener noreferrer"
        >
          <FaFacebookF />
        </FooterSocialsLink>
        <FooterSocialsLink
          href= {'https://www.instagram.com/'+data.INSTAGRAM+'/'}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={data.INSTAGRAM}
        >
          <FiInstagram />
        </FooterSocialsLink>
        <FooterSocialsLink
         href= {'https://twitter.com/h'+data.TWITTER}
                
         target="_blank"
            rel="noopener noreferrer"
            aria-label={data.TWITTER}
        >
          <IoLogoTwitter />
        </FooterSocialsLink>
      </FooterSocials>

      <FooterCopyright>
        <FooterCopyrightText>
          &copy; {new Date().getFullYear()} MobresPos All rights reserved.
        </FooterCopyrightText>
      </FooterCopyright>
    </FooterWrapper>
  );
};

export default Footer;
